(window.MyModule = function ($, Behaviors) {

    "use strict";

    var module = {};

    function OpenPositions(elem) {
        Behaviors.init(OpenPositions, this, arguments);

        var $thisElem = this.$elem,
            filterDropdown = $thisElem.find('.OpenPositions-dropdown_button'),
            filter = $thisElem.find('.OpenPositions-dropdown a'),
            category = $thisElem.parents('section').find('.OpenPositions-jobs_category'),
            position = $thisElem.parents('section').find('.OpenPositions-jobs_category_position'),
            noJobs = $thisElem.parents('section').find('.OpenPositions-jobs_nothing_found');

        // Open Positions Filters
        filter.on('click', function (e) {
            e.preventDefault();

            var $this = $(this);

            $this.parents('ul').find('li').removeClass('active');
            $this.parent().addClass('active');

            $this.parents('.OpenPositions-dropdown').find('.OpenPositions-dropdown_button_text').text($this.text());

            // get active filters
            var department = $('.OpenPositions-dropdown--departments .active') ? $('.OpenPositions-dropdown--departments .active a').attr('href') : '',
                location = $('.OpenPositions-dropdown--locations .active') ? $('.OpenPositions-dropdown--locations .active a').attr('href') : '',
                selector;

            selector = department && department !== 'undefined' ? '[data-department="' + department + '"]' : '';
            selector = location && location !== 'undefined' ? selector + '[data-location="' + location + '"]' : selector;

            console.log(selector);
            position.removeClass('OpenPositions-jobs_category_position--show');

            if (selector && selector !== 'undefined') {
                position.hide();
                $(selector).show();
                $(selector).addClass('OpenPositions-jobs_category_position--show');
            } else {
                position.show();
                position.addClass('OpenPositions-jobs_category_position--show');
            }

            category.each(function () {
                if ($(this).find('.OpenPositions-jobs_category_position--show').length > 0) {
                    $(this).show()
                } else {
                    $(this).hide();
                }
            });

            if ($thisElem.parents('section').find('.OpenPositions-jobs_category:visible').length > 0) {
                noJobs.hide();
            } else {
                noJobs.show();
            }
        });

        // Open Positions Dropdown
        filterDropdown.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if ($(this).parent().hasClass('OpenPositions-dropdown--open')) {
                filterDropdown.parent().removeClass('OpenPositions-dropdown--open');
            } else {
                filterDropdown.parent().removeClass('OpenPositions-dropdown--open');
                $(this).parent().addClass('OpenPositions-dropdown--open');
            }
        });

        $(document).on('click', function () {
            filterDropdown.parent().removeClass('OpenPositions-dropdown--open');
        });
    }

    Behaviors.inherit(OpenPositions, Behaviors.Behavior);

    OpenPositions.QUERY = "[data-job-filters]";

    Behaviors.register_behavior(OpenPositions);

    module.OpenPositions = OpenPositions;

    return module;

}(window.jQuery, window.Behaviors));